import { Injectable } from "@angular/core";
import * as _ from 'lodash';
import { SessionData } from "./session-data";

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private sessionData: SessionData;

  public constructor() { }

  /**
   * Only for module initialization.
   * To use session data, inject SessionData instead
   */
  public getSessionData(): SessionData {

    if (!this.sessionData) {
      this.sessionData = new SessionData();
    }

    return this.sessionData;

  }

  public initialize(sessionDataParam: SessionData): void {
    if (!this.sessionData) {
      this.sessionData = new SessionData();
    }

    _.extend(this.sessionData, sessionDataParam);

  }
}
